import { render, staticRenderFns } from "./videoscreenfullcontrol.vue?vue&type=template&id=0c9d955a&scoped=true&"
import script from "./videoscreenfullcontrol.vue?vue&type=script&lang=js&"
export * from "./videoscreenfullcontrol.vue?vue&type=script&lang=js&"
import style0 from "./videoscreenfullcontrol.vue?vue&type=style&index=0&id=0c9d955a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9d955a",
  null
  
)

export default component.exports